import { render } from "./MovimentarStatusFerramenta.vue?vue&type=template&id=98069ce8&scoped=true"
import script from "./MovimentarStatusFerramenta.vue?vue&type=script&lang=js"
export * from "./MovimentarStatusFerramenta.vue?vue&type=script&lang=js"

import "./MovimentarStatusFerramenta.vue?vue&type=style&index=0&id=98069ce8&scoped=true&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98069ce8"]])

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QScrollArea from 'quasar/src/components/scroll-area/QScrollArea.js';
import QInput from 'quasar/src/components/input/QInput.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QCard,QIcon,QScrollArea,QInput});
